export default {"src":"/_next/static/media/CHAINGPT.f2d14c01.svg","height":228,"width":1058,"blurWidth":0,"blurHeight":0};